import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type AddPackageDTO = {
    name:string;
    description:string;
    actualPrice_egp:string;
    actualPrice_usd:string;
};

type PackageResponse  = AddPackageDTO & {
    id:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;

export const EditPackage = (data: AddPackageDTO, id:string): Promise<PackageResponse> => {
    return axios.patch(`/package/${id}`, data)
        .then(response => response.data as PackageResponse);
};